import { AlergiasService } from './../services/alergias.service';

export class Alergia {
  private alergiaSv: AlergiasService;
  id?: number;
  idAlergia?: number;
  nome?: string;
  numeroCartao?: string;
  outra?: string;
  tipo?: number;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      this.idAlergia = data.idAlergia;
      this.nome = data.nome;
      this.numeroCartao = data.numeroCartao;
      this.outra = data.outra;
      this.tipo = data.tipo;
    }
  }

  public static fromDTO?(data) {
    const alergia = new Alergia();
    alergia.id = data.id;
    alergia.idAlergia = data.idAlergia;
    alergia.nome = data.nome;
    alergia.numeroCartao = data.numeroCartao;
    alergia.outra = data.outra;
    alergia.tipo = data.tipo;
    return alergia;
  }

  public toDTO?() {
    const dto: any = {};
    dto.id = this.id;
    dto.idAlergia = this.idAlergia;
    dto.nome = this.nome;
    dto.numeroCartao = this.numeroCartao;
    dto.outra = this.outra;
    dto.tipo = this.tipo;
    return dto;
  }

}
